import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '../../../src/lib/utils';
export type StepImageAsset = {
  src: string;
  alt: string;
  width: number;
  height: number;
  /** Crop the image to show only a region (e.g. the product UI below a headline). */
  crop?: {
    aspect: string;
    position: string;
  };
};

/** Product screenshot shown beside a story step, framed like a product panel. */
export function StepImage({
  image,
  className
}: {
  image: StepImageAsset;
  className?: string;
}) {
  const reduceMotion = useReducedMotion();
  return <motion.figure {...reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  }} className={cn('overflow-hidden rounded-2xl border border-hairline bg-surface shadow-[0_24px_60px_-40px_rgba(32,22,95,0.3)]', className)} data-id="element-80" data-mp="10puzo637mh2x">
      <div className="relative w-full" style={{
      aspectRatio: image.crop?.aspect ?? `${image.width} / ${image.height}`
    }} data-id="element-81" data-mp="19qvm6nr6049e">
        <img src={image.src} alt={image.alt} width={image.width} height={image.height} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" style={{
        objectPosition: image.crop?.position ?? 'center'
      }} data-id="element-82" data-mp="15mnx2pgsoman" />
      </div>
    </motion.figure>;
}